import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MainButton from "./Buttons/MainButton";
import ModalShell, { ModalTitle } from "./ModalShell";

function WarningMessageModal({ title, description, open, handleClose }) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalShell
        accent="warning"
        icon={<ErrorOutlineIcon sx={{ width: "38px", height: "38px", color: "#FFFFFF" }} />}
        onClose={() => handleClose(false)}
        width="min(620px, calc(100vw - 32px))"
      >
          <ModalTitle accent="warning">{title}</ModalTitle>
          <p className="mb-7 text-[16px] leading-8 text-slate-600">{description}</p>
          <div className="flex w-full justify-center">
            <MainButton onClick={() => handleClose(false)} text="Close" />
          </div>
      </ModalShell>
    </Modal>
  );
}

export default WarningMessageModal;
